module.exports = __webpack_public_path__ + "img/banerbarra.bdb49f13.png";